import { SC } from "@helper/ServerCall";
import { translation_api } from "@src/views/v3/Helper/endPoints";

class TranslationService {
  /**
   * CREATEA TRANSLATIONS
   */
  static upsertTranslations = async (payload, id) => {
    try {
      const endpoint = id ? `${translation_api}/${id}` : translation_api;
      const requestMethod = id ? "putCall" : "postCall";
      const response = await SC[requestMethod](endpoint, payload);
      return response.data;
    } catch (error) {
      return error;
    }
  };
  /**
   * GET TRANSLATION BY ID
   */
  static fetchTranslation = async (params) => {
    try {
      const response = await SC.getCall(translation_api + `/${params.id}`);
      return response?.data;
    } catch (error) {
      return error;
    }
  };
  /**
   * GET TRANSLATIONS
   */
  static fetchTranslations = async (params) => {
    try {
      const response = await SC.getCall(translation_api, params);
      return response?.data;
    } catch (error) {
      return error;
    }
  };
}

export default TranslationService;
